module.exports = __webpack_public_path__ + "img/paytable_icon.ab524c2a.svg";